import React from 'react';

import { AccountCircle } from '@mui/icons-material';
import {
  MenuItem,
  Button,
  Typography,
  Box,
  TextField,
  InputAdornment,
} from '@mui/material';

import { addToBoard, addAllToBoard } from './helpers';
import { KdKanban, ProvinceLite } from '../../@types/State';
import EnemySwitcher from '../Common/EnemySwitcher';

interface Props {
  provinces: ProvinceLite[] | undefined;
  province: ProvinceLite | undefined;
  handleProvinceChange: (e: any) => void;
  handleLoadClick: (e: any) => void;
  handleSaveClick: (e: any) => void;
  state: KdKanban;
  setState: (state: KdKanban) => void;
  message: string;
  showNotes: boolean;
  setShowNotes: React.Dispatch<React.SetStateAction<boolean>>;
  isWarPlan: boolean;
}
const buttonStyles = { height: '40px', marginRight: '10px' };
const TopActions: React.FC<Props> = ({
  provinces,
  province,
  handleProvinceChange,
  handleLoadClick,
  handleSaveClick,
  state,
  setState,
  message,
  showNotes,
  setShowNotes,
  isWarPlan,
}) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }} mb={2}>
        <Typography variant='h2' component='div' sx={{ marginRight: 2 }}>
          {isWarPlan ? 'War Planner' : 'KD Roles'}
        </Typography>
        {isWarPlan && <EnemySwitcher />}
        <Button
          variant='outlined'
          onClick={handleLoadClick}
          sx={{ ...buttonStyles, marginLeft: '10px' }}
        >
          Load
        </Button>
        <Button
          variant='outlined'
          onClick={handleSaveClick}
          sx={{ ...buttonStyles, marginRight: 0 }}
        >
          Save
        </Button>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          direction: 'row',
          alignItems: 'center',
        }}
      >
        <Button
          variant='outlined'
          size='small'
          onClick={() => setShowNotes(!showNotes)}
          sx={buttonStyles}
        >
          Summary
        </Button>
        <Button
          variant='outlined'
          size='small'
          onClick={() => addAllToBoard(state, provinces, setState)}
          sx={buttonStyles}
        >
          Add Provinces
        </Button>
        <Button
          variant='outlined'
          size='small'
          onClick={() => addToBoard(state, province, setState)}
          sx={{ ...buttonStyles, marginright: 0 }}
        >
          Add Group
        </Button>
        {message && (
          <Typography variant='body1' sx={{ color: 'red', marginLeft: '5px' }}>
            {message}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default TopActions;
